module.exports = __webpack_public_path__ + "img/multiplication-and-division-math-magic-tip1.ad8f0233.png";